module.exports = __webpack_public_path__ + "img/244.room_conditions.73e84dff.svg";